let app = angular.module('app', ['angular-jsonrpc-client', 'duScroll', 'ngCookies']);

app.config([ '$locationProvider', 'jsonrpcConfigProvider', 'LANG', function ($locationProvider, jsonrpcConfigProvider, LANG) {
    jsonrpcConfigProvider.set({
        url: LANG.path + '/api/'
    });

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
        rewriteLinks: false
    });
}]);

app.filter('nicePrice', function () {
    return function (value) {
        if (value)
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return '0';
    }
});

app.filter('price', ['currencyService', function (currencyService) {
    return currencyService.format;
}]);

app.filter('compactPrice', ['currencyService', function (currencyService) {
    return currencyService.formatCompact;
}]);

app.filter('compactPriceRange', ['currencyService', function (currencyService) {
    return currencyService.formatCompactRange;
}]);

app.directive('uiModal', ['$templateRequest', '$compile', function ($templateRequest, $compile) {
    return {
        restrict: "A",
        replace: true,
        transclude: true,
        template: '' +
            '<div class="modal-container" data-ng-click="closeModal();" >' +
            '    <div class="modal" data-ng-class="modal.class" data-ng-click="$event.stopPropagation();">' +
            '        <div class="modal__inner" data-ui-select-hide=""></div>' +
            '    </div>' +
            '</div>',
        link: function ($scope, element, attrs) {
            $scope.$watch('modal.tpl', function (tpl) {
                if (tpl) {
                    $templateRequest(tpl).then(function (html) {
                        let template = angular.element(html);
                        angular.element(element[0].querySelector('.modal__inner')).empty().append(template);
                        $compile(template)($scope);
                    });
                }
            });
        }
    }
}]);

app.directive('uiToggle', function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function ($event) {
                angular.element(this).toggleClass(attrs['uiToggle']);
                $event.preventDefault();
                $event.stopPropagation();
                return false;
            })
        }
    }
});

app.directive('uiNav', function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            const nav = element[0];
            const toggles = nav.querySelectorAll('.nav__item:has(.subnav) > .nav__link');

            toggles.forEach(toggle => {
                toggle.addEventListener('click', function (e) {
                    const currentItem = toggle.closest('.nav__item');
                    const currentSubnav = currentItem.querySelector('.subnav');
                    const isOpen = currentItem.classList.contains('active');

                    nav.querySelectorAll('.nav__item.active').forEach(item => {
                        if (item === currentItem) return;

                        const subnav = item.querySelector('.subnav');
                        if (subnav) {
                            subnav.style.maxHeight = '0px';
                        }
                        item.classList.remove('active');
                    });

                    if (isOpen) {
                        currentSubnav.style.maxHeight = '0px';
                        currentItem.classList.remove('active');
                    } else {
                        currentSubnav.style.maxHeight = currentSubnav.scrollHeight + 'px';
                        currentItem.classList.add('active');
                    }

                    e.preventDefault();
                    e.stopPropagation();
                });
            });
        }
    }
});

app.directive('uiLink', function () {
    return {
        restrict: "A",
        scope: {
            uiLink: '<'
        },
        link: function ($scope, element, attrs) {
            const baseHref = element.attr('data-base-href') || element.attr('href') || '';

            function updateHref() {
                const path = $scope.uiLink ? $scope.uiLink.path : null;
                const href = baseHref + (path ? path + '/' : '')
                if (element.attr('href') !== href) {
                    element.attr('href', href);
                }
            }

            $scope.$watch('uiLink', function () {
                updateHref();
            });
            updateHref();
        }
    }
});

app.directive('uiLanguageLink', ['LANG', '$window', function (LANG, $window) {
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            const languagePath = attrs.uiLanguageLink === 'th'
                ? ''
                : '/' + attrs.uiLanguageLink;

            element.on('click', function () {
                const route = $window.location.pathname.slice(LANG.path.length);
                element.attr(
                    'href',
                    languagePath + route + $window.location.search
                );
            });
        }
    };
}]);

app.directive('uiPreserveQuery', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            const names = attrs.uiPreserveQuery.split(',');

            element.on('click', function () {
                const href = element.attr('href');
                const current = new URLSearchParams($window.location.search);
                const target = new URL(href, $window.location.origin);

                names.forEach(function (name) {
                    name = name.trim();
                    if (current.has(name)) {
                        target.searchParams.set(name, current.get(name));
                    } else {
                        target.searchParams.delete(name);
                    }
                });

                element.attr(
                    'href',
                    target.pathname + target.search + target.hash
                );
            });
        }
    };
}]);

app.directive('uiSwipe', function () {
    return {
        restrict: 'A',
        scope: {
            update: "&uiSwipe",
            direction: "@direction",
        },
        link: function ($scope, element, attrs) {
            const direction = $scope.direction || "right"

            const minDist = 50;   // px
            const maxTime = 500;  // ms

            let startX = 0, startY = 0, startTime = 0;
            let tracking = false;

            function getPoint(e) {
                if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
                if (e.touches && e.touches.length) return e.touches[0];
                return e; // fallback for mouse/pointer
            }

            function onStart(e) {
                const p = getPoint(e);
                startX = p.pageX;
                startY = p.pageY;
                startTime = Date.now();
                tracking = true;
            }

            function onEnd(e) {
                if (!tracking) return;
                tracking = false;

                const elapsed = Date.now() - startTime;
                if (elapsed > maxTime) return;

                const p = getPoint(e);
                const dx = p.pageX - startX;
                const dy = p.pageY - startY;
                const absX = Math.abs(dx);
                const absY = Math.abs(dy);

                let detected = '';
                if (absX > absY && absX >= minDist) {
                    detected = dx > 0 ? 'right' : 'left';
                } else if (absY > absX && absY >= minDist) {
                    detected = dy > 0 ? 'down' : 'up';
                }

                if (detected && detected === direction) {
                    $scope.$applyAsync(() => {
                        $scope.update();
                    });
                }
            }

            // Touch
            element.on('touchstart', onStart);
            element.on('touchend', onEnd);

            // Mouse (for testing)
            element.on('mousedown', onStart);
            element.on('mouseup', onEnd);
        }
    };
})

app.directive('uiVideo', function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let elementFirst = angular.element(element[0]);
            elementFirst.on('click', function (e) {
                elementFirst.replaceWith('' +
                    '<iframe src="' + elementFirst.attr('data-ui-video') + '" ' +
                    'style="min-height: ' + elementFirst[0].offsetHeight + 'px" ' +
                    'referrerpolicy="strict-origin-when-cross-origin" ' +
                    'allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ' +
                    'allowfullscreen></iframe>');
                e.preventDefault();
                e.stopPropagation();
            })
        }
    }
});

app.directive('ngDialog', ['$timeout', 'statService', function ($timeout, statService) {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let timer = null;
            let propertyId = attrs['propertyId'];

            angular.element(element[0].querySelector('.js-action')).on('click', function (e) {
                angular.element(element[0]).removeClass('message').removeClass('count').addClass('active');
                if (timer) $timeout.cancel(timer);
                if (propertyId) statService.interestProperty(propertyId);
            });

            angular.element(element[0].querySelector('.js-close')).on('click', function (e) {
                angular.element(element[0]).removeClass('active');
            });

            angular.element(element[0].querySelectorAll('.js-button')).on('click', function (e) {
                statService.richContactGoal();
                if (propertyId) statService.requestProperty(propertyId);
            });

            timer = $timeout(function () {
                angular.element(element[0]).removeClass('hide');
            }, 100);

            timer = $timeout(function () {
                angular.element(element[0]).addClass('count');
            }, 3000);

            timer = $timeout(function () {
                // angular.element(element[0]).removeClass('count');
                // angular.element(element[0]).addClass('message');
            }, 10000);
        }
    }
}]);

app.directive('ngBindStats', ['$timeout', 'statService', function ($timeout, statService) {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let propertyId = attrs['propertyId'];
            angular.element(element[0].querySelectorAll('.js-contact')).on('click', function (e) {
                statService.richContactGoal();
                if (propertyId) statService.requestProperty(propertyId);
            });
        }
    }
}]);

app.directive('uiLoader', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        template: '<div class="loader" ng-show="counter>0"><div class="loader-spinner"><div class="loader-wave"><div></div></div></div></div>',
        link: function ($scope, el, attrs) {
            $scope.counter = 0;
            $scope.incCounter = function () {
                $scope.counter++;
                $timeout(function () {
                    $scope.decCounter();
                }, 20000)
            };
            $scope.decCounter = function () {
                $scope.counter = $scope.counter > 0 ? $scope.counter - 1 : 0;
            };

            $rootScope.$on('preloader:active', function (event) {
                $scope.incCounter()
            });
            $rootScope.$on('preloader:hide', function (event) {
                $scope.decCounter();
            });
        }
    }
}]);

app.directive('uiTabs', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            const root = element[0];
            const baseClass = attrs.uiTabs || '.tabs';
            const items = angular.element(root.querySelectorAll(baseClass + '__nav > li'));

            items.on('click', function () {
                const tab = this;
                const tabId = tab.getAttribute('data-for');
                const panel = tabId && root.querySelector(baseClass + '__block#' + tabId);
                if (!panel) return;

                items.removeClass('active');
                angular.element(root.querySelectorAll(baseClass + '__block.active')).removeClass('active');
                angular.element(tab).addClass('active');
                angular.element(panel).addClass('active');
            });
        }
    };
}]);

app.directive('uiHiddenText', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let height = attrs['uiHiddenText'] ? attrs['uiHiddenText'] : 200;
            let content = angular.element(element[0].querySelectorAll('.hidden-text__content'))[0];
            let more = angular.element(element[0].querySelectorAll('.hidden-text__more'));
            content.style = 'max-height: ' + height + 'px';
            let current_height = content.scrollHeight;
            if (current_height > height) {
                element.removeClass('hidden');
                more.on('click', function () {
                    element.toggleClass('active');
                    if (element.hasClass('active')) {
                        more[0].innerText = more.attr('data-less');
                    } else {
                        more[0].innerText = more.attr('data-more');
                    }
                });
            } else {
                element.addClass('disabled');
            }
        }
    }
}]);

app.directive('uiHeightParent', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let el = element[0]
            let height = el.parentElement.scrollHeight;
            el.style.height = height + 'px';
        }
    }
}]);

app.directive('uiPlans', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0].querySelectorAll('.plan__nav > li')).on('click', function (e) {
                angular.element(element[0].querySelectorAll('.plan__nav > li.active')).removeClass('active');
                angular.element(element[0].querySelectorAll('.plan__image.active')).removeClass('active');
                angular.element(e.target).addClass('active');
                let tabId = angular.element(e.target).attr('data-for');
                angular.element(element[0].querySelector('.plan__image#' + tabId)).addClass('active');
            });
        }
    };
}]);

app.directive('uiTags', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0].querySelectorAll('li[data-tag]')).on('click', function (e) {
                angular.element(element[0].querySelectorAll('li.active[data-tag]')).removeClass('active');
                angular.element(e.target).addClass('active');
                let activeTag = angular.element(e.target).attr('data-tag');
                let elements = angular.element(element[0].querySelectorAll('a[data-tags]'));
                if (activeTag) {
                    for (let i = 0; i < elements.length; i++) {
                        let element = angular.element(elements[i]);
                        if (element.attr('data-tags').split(' ').indexOf(activeTag) > -1)
                            element.removeClass('hide');
                        else
                            element.addClass('hide');
                    }
                } else {
                    let elements = angular.element(element[0].querySelectorAll('a.hide[data-tags]'));
                    for (let i = 0; i < elements.length; i++) {
                        angular.element(elements[i]).removeClass('hide');
                    }
                }
            });
        }
    };
}]);

app.directive('uiSlider', [function () {
    return {
        restrict: "A",
        scope: {
            value: "=uiSlider",
            range: "=",
            step: "=",
            update: "&",
            middle: "="
        },
        link: function ($scope, element, attrs) {
            let slider = element[0];
            let middle = $scope.middle ? $scope.middle : 50;

            noUiSlider.create(slider, {
                start: [$scope.value],
                step: $scope.step,
                connect: [true, false],
                range: {
                    'min': $scope.range[0],
                    '50%': Math.floor(($scope.range[1] - $scope.range[0]) * middle / 100),
                    'max': $scope.range[1]
                }
            });

            slider.noUiSlider.on('update', function (values, handle) {
                let value = parseInt(values[0]);

                $scope.$applyAsync(function () {
                    $scope.value = value;
                })
            });

            slider.noUiSlider.on('change', function (values, handle) {
                $scope.$applyAsync(function () {
                    $scope.update();
                });
            });
        }
    };
}]);

app.directive('uiSelectHide', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function () {
                angular.element(element[0].querySelectorAll('.select.active')).removeClass("active");
            });
        }
    };
}]);

app.directive('uiPreventClick', ['$window', function ($window) {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function ($event) {
                let maxWidth = parseInt(attrs['uiPreventClick']);
                if ($window.innerWidth < maxWidth) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    return false;
                }
            });
        }
    };
}]);

app.directive('uiHeader', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let doc = document.documentElement;
            let w = window;
            let prevScroll = w.scrollY || doc.scrollTop;
            let curScroll;
            let direction = 0;
            let prevDirection = 0;

            let header = element;

            let checkScroll = function () {

                curScroll = w.scrollY || doc.scrollTop;
                if (curScroll > prevScroll) {
                    //scrolled up
                    direction = 2;
                } else if (curScroll < prevScroll) {
                    //scrolled down
                    direction = 1;
                }

                if (direction !== prevDirection) {
                    toggleHeader(direction, curScroll);
                }

                prevScroll = curScroll;
            };

            let toggleHeader = function (direction, curScroll) {
                if (direction === 2 && curScroll > 60) {
                    header.addClass('hidden');
                    prevDirection = direction;
                } else if (direction === 1) {
                    header.removeClass('hidden');
                    prevDirection = direction;
                }
            };

            window.addEventListener('scroll', checkScroll);
        }
    };
}]);

app.directive('uiSelect', [function () {
    return {
        restrict: "A",
        scope: {
            selected: "=uiSelect",
            list: "=",
            empty: "@",
            label: "@?",
            key: "@",
            trackBy: "@",
            value: "@",
            indent: "<?",
            update: "&"
        },
        template: '' +
            '<div class="select__value">' +
            '    <span class="select__label" data-ng-if="label">{{label}}</span> ' +
            '    <span class="select__text">{{selectedItem?getValue(selectedItem):empty}}</span>' +
            '</div>' +
            '<div class="select__list">' +
            '    <div class="select__option empty"' +
            '         data-ng-if="empty"' +
            '         data-ng-click="select(null)">{{ empty }}</div>' +
            '    <div class="select__option" data-ng-class="{\'ident\':shouldIndent(item), \'current\':isSelected(item)}"' +
            '         data-ng-repeat="item in list"' +
            '         data-ng-click="select(item)">{{getValue(item)}}</div>' +
            '</div>',
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function (e) {
                if (angular.element(this).hasClass("active")) {
                    if (closest(angular.element(this).parent(), 'active')) {
                        angular.element(this).removeClass("active");
                    } else {
                        angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                    }
                } else {
                    if (!closest(angular.element(this).parent(), 'active')) {
                        angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                    }
                    angular.element(this).addClass("active");
                }
                e.stopPropagation();
            });

            function closest(element, className) {
                if (element[0].nodeName === 'HTML') {
                    return null;
                } else if (element.hasClass(className) && element.hasClass('select')) {
                    return element;
                } else {
                    return closest(element.parent(), className);
                }
            }


            $scope.shouldIndent = function (item) {
                return $scope.indent !== false && !!item.parent_id;
            };


            $scope.select = function (item) {
                if (getKey($scope.selectedItem) === getKey(item)) return;

                $scope.selectedItem = item;
                $scope.selected = key && item ? item[key] : item;

                $scope.$$postDigest(function () {
                    $scope.$applyAsync(function () {
                        $scope.update();
                    });
                });
            };


            let value = $scope.value;
            $scope.getValue = function (item) {
                return (value && item != null) ? item[value] : item;
            };

            let trackBy = $scope.trackBy;
            let getKey = function (item) {
                return (trackBy && item != null) ? item[trackBy] : item;
            };

            $scope.isSelected = function (item) {
                return $scope.selectedItem != null && getKey($scope.selectedItem) === getKey(item);
            };

            //set selected item if selected changed or init
            let key = $scope.key;
            $scope.$watch('selected', function (value) {
                if (value == null) {
                    $scope.selectedItem = null;
                    return;
                }
                if (key) {
                    if ($scope.selectedItem && $scope.selectedItem[key] === value) return;

                    $scope.selectedItem = null;
                    for (let i = 0; i < $scope.list.length; i++) {
                        if ($scope.selected === $scope.list[i][key]) {
                            $scope.selectedItem = $scope.list[i];
                            break;
                        }
                    }
                } else {
                    $scope.selectedItem = $scope.selected;
                }
            });

            //if empty and no default set first
            if (!$scope.empty && !$scope.selected && $scope.list.length > 1) {
                $scope.selectedItem = $scope.list[0];
            }
        }
    };
}]);

app.directive('uiSelectStatic', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function (e) {
                let el = angular.element(this);
                if (el.hasClass("active")) {
                    el.removeClass("active");
                } else {
                    angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                    el.addClass("active");
                }
                e.stopPropagation();
            });

            if (attrs.update) {
                let options = element[0].querySelectorAll('.select__option');
                angular.element(options).on('click', function () {
                    $scope.$applyAsync(function () {
                        $scope.$eval(attrs.update);
                    });
                });
            }
        }
    };
}]);

app.directive('uiSelectBox', [function () {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function (e) {
                angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                angular.element(this).addClass("active");
                e.stopPropagation();
            });

            angular.element(element[0].querySelector('.select__value')).on('click', function (e) {
                if (angular.element(this).parent().hasClass('active')) {
                    angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                    e.stopPropagation();
                }
            });
        }
    };
}]);

app.directive('uiSelectBtn', [function () {
    return {
        restrict: "A",
        scope: {
            selected: "=uiSelectBtn",
            list: "=",
            key: "@",
            trackBy: "@",
            value: "@",
            update: "&",
            multiple: "="
        },
        template: '' +
            '<button class="btn-select__option btn" ' +
            '        data-ng-repeat="item in list" ' +
            '        data-ng-class="{active: isActive(item)}" ' +
            '        data-ng-click="select(item)">{{getValue(item)}}</button>',
        link: function ($scope, element, attrs) {
            let key = $scope.key;
            let trackBy = $scope.trackBy;
            let value = $scope.value;

            if ($scope.multiple) {
                $scope.select = function (item) {
                    let items = $scope.selected;
                    let found = false;
                    for (let i in items) {
                        if (getKey(item) === getSelectedKey(items[i])) {
                            items.splice(i, 1);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        items.push(getSelectedValue(item));
                    }

                    $scope.$$postDigest(function () {
                        $scope.$applyAsync(function () {
                            $scope.update();
                        });
                    });
                };
                $scope.isActive = function (item) {
                    let items = $scope.selected;
                    for (let i in items) {
                        if (getKey(item) === getSelectedKey(items[i])) {
                            return true
                        }
                    }
                    return false;
                };
            } else {
                $scope.select = function (item) {
                    if (getSelectedKey($scope.selected) === getKey(item)) {
                        item = null;
                    }

                    $scope.selected = getSelectedValue(item);

                    $scope.$$postDigest(function () {
                        $scope.$applyAsync(function () {
                            $scope.update();
                        });
                    });
                };
                $scope.isActive = function (item) {
                    return getKey(item) === getSelectedKey($scope.selected);
                };
            }

            $scope.getValue = function (item) {
                return (value && item != null) ? item[value] : item;
            };

            let getKey = function (item) {
                return (trackBy && item != null) ? item[trackBy] : item;
            };

            let getSelectedKey = function (item) {
                return key ? item : getKey(item);
            };
            let getSelectedValue = function (item) {
                return key ? getKey(item) : item;
            };

        }
    };
}]);

app.directive('uiMapPin', ['$window', 'googleMapsLoader', 'GOOGLE_MAPS_CONFIG', function ($window, googleMapsLoader, GOOGLE_MAPS_CONFIG) {
    return {
        restrict: 'A',
        scope: {location: '=uiMapPin'},
        link: function ($scope, element) {
            let destroyed = false;
            let marker = null;
            let observer = new $window.IntersectionObserver(function (entries) {
                if (destroyed || !entries.some(function (entry) {
                    return entry.isIntersecting;
                })) return;

                observer.disconnect();
                googleMapsLoader.load().then(function (maps) {
                    if (destroyed || !$scope.location) return;
                    createMapWithPin(maps);
                }).catch(angular.noop);
            }, {rootMargin: '0px 0px 200px 0px'});

            observer.observe(element[0]);
            $scope.$on('$destroy', function () {
                destroyed = true;
                observer.disconnect();
                if (marker) marker.map = null;
            });

            function createMapWithPin(maps) {
                let location = $scope.location;
                let position = {lat: location.lat, lng: location.lng};
                let map = new maps.Map(element[0], {
                    center: position,
                    zoom: location.zoom,
                    mapId: GOOGLE_MAPS_CONFIG.mapId
                });
                let pin = new maps.PinElement({
                    background: '#EA4335',
                    borderColor: '#ffffff',
                    glyphColor: '#ffffff',
                    scale: 1.1
                });
                marker = new maps.AdvancedMarkerElement({
                    map: map,
                    position: position
                });
                marker.append(pin);
            }
        }
    };
}]);

app.directive('uiStickyMenu', ['$document', function ($document) {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            let menu = element[0];

            let headerHeight = document.getElementById('header').offsetHeight;
            let stickyOffset = menu.offsetTop - headerHeight - 1 + 6;
            let scrollOffset = headerHeight + menu.offsetHeight - 1;

            let links = menu.querySelectorAll('.nav__link');
            let sections = [];
            links.forEach(function (link, index) {
                let offset = link.dataset.offset ? parseInt(link.dataset.offset) : 0;
                let sectionElement = document.querySelector(link.getAttribute('href'));
                if (sectionElement) {
                    sections.push({index: index, element: sectionElement});
                    link.addEventListener('click', function (event) {
                        $document.scrollTop(sectionElement.offsetTop - scrollOffset - offset, 500);
                        event.preventDefault();
                        return false;
                    });
                }
            });

            let activeIndex = null;
            let currentIndex = 0;

            function onScroll() {
                if (window.pageYOffset > stickyOffset) {
                    menu.classList.add("sticky");
                } else {
                    menu.classList.remove("sticky");
                }

                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i];
                    if (window.pageYOffset > (section.element.offsetTop - scrollOffset - 50)) {
                        currentIndex = section.index;
                        if (window.pageYOffset > (section.element.offsetTop + section.element.offsetHeight - scrollOffset)) {
                            currentIndex = null;
                        }
                    } else {
                        break;
                    }
                }

                if (activeIndex !== currentIndex) {
                    if (activeIndex != null) links[activeIndex].classList.remove('active');
                    if (currentIndex != null) {
                        links[currentIndex].classList.add('active');
                        scrollToVisible(menu.querySelector('nav'), links[currentIndex]);
                    }
                    activeIndex = currentIndex;
                }
            }

            function scrollToVisible(container, element) {
                let navLeft = container.scrollLeft;
                let navRight = navLeft + container.offsetWidth;
                let currentLeft = element.offsetLeft;
                let currentRight = currentLeft + element.offsetWidth;
                if (navLeft > currentLeft) {
                    container.scrollLeft = currentLeft - 10;
                } else if (navRight < currentRight) {
                    container.scrollLeft += (currentRight - navRight) + 10;
                }
            }

            window.onscroll = onScroll;
            onScroll();
        }
    }
}]);

app.directive('uiCookieNotes', ['$cookies', function ($cookies) {
    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            const USER_CONSENT_CN = 'user_cookie_consent';

            $scope.showCookieNotice = false;

            $scope.checkUpdateCookieNotice = function () {
                $scope.showCookieNotice = $cookies.get(USER_CONSENT_CN) === undefined;
            };

            $scope.acceptCloseCookieNotice = function () {
                let now = new Date();
                // set expire date in 1 month after click accept
                let expireDate = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
                $cookies.put(USER_CONSENT_CN, 1, {path: '/', expires: expireDate});
                $scope.showCookieNotice = false;
            };

            $scope.checkUpdateCookieNotice();
        }
    }
}]);

app.service('videoService', ['rpcService', function (rpcService) {
    let videos = new Map();
    let videoBackgrounds = new VideoBackgrounds();

    this.initVideo = function (videoId, element, button) {
        let video = {
            'id': videoId,
            'element': element,
            'button': button,
            'is_loading': false,
            'is_loaded': false,
            'is_play': false,
            'player': null
        }
        videos.set(videoId, video);
        // init events
        return video;
    }

    this.playVideo = function (video) {
        if (!video) return;

        video.is_play = true;
        if (video.is_loaded) {
            video.player.play();
        } else {
            this.loadVideo(video);
        }
    }

    this.stopVideo = function (video) {
        if (!video) return;

        video.is_play = false;
        if (video.is_loaded) {
            video.player.pause();
            // video.player.seek(0);
        }
    }

    this.loadVideo = function (video) {
        if (video.is_loaded || video.is_loading) return;
        video.is_loading = true;
        video.button.classList.add('loading');
        this.getVideo(video.id).then(function (data) {
            video.element.setAttribute('data-youtube', data.external_url)
            if (data.is_vertical) video.element.classList.add('vertical')

            videoBackgrounds.add(video.element, {'autoplay': false, 'lazyloading': true, offset: 90});

            video.element.addEventListener('video-background-ready', function (event) {
                video.player = videoBackgrounds.get(video.element)
                video.is_loaded = true;
                video.is_loading = false;
                video.button.classList.remove('loading');
                if (video.is_play) {
                    video.player.play();
                }
            });

            video.element.addEventListener('video-background-play', function (event) {
                video.element.classList.add('active');
                video.button.classList.add('active');
            });

            video.element.addEventListener('video-background-pause', function (event) {
                video.element.classList.remove('active');
                video.button.classList.remove('active');
            });
        });

    }

    this.getVideo = function (video_id) {
        return rpcService.call('video.get', {'video_id': video_id}, false);
    }

    this.findVideo = function (video_id) {
        return videos.has(video_id) ? videos.get(video_id) : null;
    }
}]);

app.directive('ngGallery', ['$timeout', '$window', 'videoService', function ($timeout, $window, videoService) {
    let timer = 0;
    let delay = 1000;

    let observer = new IntersectionObserver(function (entries, obs) {
        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];
            let videoId = entry.target.closest('[data-video-id]').getAttribute('data-video-id')
            if (!videoId) return;
            let video = videoService.findVideo(videoId)
            if (entry.isIntersecting) {
                if (entry.target.offsetWidth < 240) return;
                $timeout.cancel(timer)
                timer = $timeout(function () {
                    videoService.playVideo(video)
                }, delay)
            } else {
                // $timeout.cancel(timer)
                videoService.stopVideo(video)
            }
        }
    }, {root: null, rootMargin: '-20% 0px -15% 0px', threshold: 0.8});

    let imagesToHtml = function (images, key) {
        let html = '<div class="siema fr"><div class="item__video"></div><div class="siema__images frc">';
        if (images && images.length) {
            for (let i = 0; i < images.length; i++) {
                let image = images[i];
                html += '<img src="' + (key ? image[key] : image) + '" loading="lazy" />'
            }
        }
        html += '</div><div class="siema__nav" onclick="return false;"><button class="prev"></button><button class="next"></button></div></div>';
        return html;
    }

    let loadImages = function (slider, lazyLoad, key) {
        if (!lazyLoad || !slider) return;
        key = key || 'thumb'

        lazyLoad().then(function (images) {
            if (!images || !Array.isArray(images)) return;
            const extraImages = images.slice(5);
            if (!extraImages.length) return;

            for (const image of extraImages) {
                if (!image || !image.thumb) continue;

                const img = document.createElement('img');
                img.src = key ? image[key] : image;
                img.loading = 'lazy';

                slider.append(img)
            }
        })
    }

    return {
        restrict: "A",
        scope: {
            images: "=ngGallery",
            videoId: "@",
            vtourId: "@",
            key: "@",
            lazyLoad: "&",
        },
        link: function ($scope, element, attrs, ctrl, transclude) {
            if ($scope.images && $scope.images.length) {
                element.append(imagesToHtml($scope.images, $scope.key));
            }
            let imagesContainer = element[0].querySelector('.siema__images');
            if (!imagesContainer.querySelectorAll('img').length) return false;

            const slider = new Siema({
                selector: imagesContainer,
                loop: true,
                duration: 500,
                onChange: function () {
                    // console.log(this.currentSlide)
                    if (this.currentSlide > 2 && !this._imagesLoaded) {
                        if ($scope.lazyLoad) {
                            setTimeout(() => loadImages(this, $scope.lazyLoad), 520);
                        }
                        this._imagesLoaded = true;
                    }
                }
            });
            element[0].querySelector('.prev').addEventListener('click', () => slider.prev());
            element[0].querySelector('.next').addEventListener('click', () => slider.next());

            if ($scope.videoId) {
                angular.element(element[0].querySelector('.item__icons')).append('<i class="icon-camera"></i>')

                let delay = 1000;
                let videoId = $scope.videoId;
                let videoElement = element[0].querySelector('.item__video');
                let videoIconElement = element[0].querySelector('.icon-camera');

                let video = videoService.initVideo(videoId, videoElement, videoIconElement)

                videoIconElement.addEventListener('click', function (e) {
                    if (video.is_play) {
                        videoService.stopVideo(video);
                    } else {
                        videoService.playVideo(video);
                    }

                    e.preventDefault();
                    return false;
                })
                element[0].querySelector('.prev').addEventListener('click', () => videoService.stopVideo(video));
                element[0].querySelector('.next').addEventListener('click', () => videoService.stopVideo(video));

                if ($window.innerWidth > 500) {
                    element[0].addEventListener('mouseenter', function () {
                        $timeout.cancel(timer)
                        timer = $timeout(function () {
                            videoService.playVideo(video)
                        }, delay)
                    })

                    element[0].addEventListener('mouseleave', function () {
                        $timeout.cancel(timer)
                        videoService.stopVideo(video)
                    })
                } else if (element[0].offsetWidth > 240) {
                    observer.observe(element[0])
                }

            }

            if ($scope.vtourId) {
                angular.element(element[0].querySelector('.item__icons')).append('<i class="icon-360-tour"></i>')
            }
        }

    };
}]);

app.directive('ngSlider', [function () {
    return {
        restrict: "A",
        scope: {
            perPage: '<'
        },
        link: function ($scope, element, attrs) {
            let sliderContainer = element[0].querySelector('.ng-container') || element[0];

            if (!sliderContainer.querySelectorAll('.ng-item').length) return false;

            let perPage = $scope.perPage || 1;
            let loop = attrs.loop !== 'false';

            const slider = new Siema({
                selector: sliderContainer,
                perPage: perPage,
                loop: loop,
                duration: 500,
            });
            element[0].querySelector('.ng-nav .prev').addEventListener('click', () => slider.prev());
            element[0].querySelector('.ng-nav .next').addEventListener('click', () => slider.next());
        }

    };
}]);

app.directive('ngTrack', ['$parse', function ($parse) {
    function isAtEnd(container) {
        return container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    }

    function isNearEnd(container) {
        const remaining = container.scrollWidth - container.clientWidth - container.scrollLeft;
        return remaining <= container.clientWidth * 0.5;
    }

    function updateNavs(container, prev, next, canLoadMore) {
        if (!prev || !next) return;

        prev.disabled = container.scrollLeft <= 1;
        next.disabled = isAtEnd(container) && !canLoadMore;
    }

    function scroll(container, dir) {
        const amount = container.clientWidth * 0.5;

        const maxScroll = container.scrollWidth - container.clientWidth;
        const current = container.scrollLeft;

        let target = dir === "right"
            ? current + amount
            : current - amount;

        target = Math.max(0, Math.min(target, maxScroll));

        container.scrollTo({
            left: target,
            behavior: "smooth"
        });
    }

    return {
        restrict: "A",
        link: function ($scope, element, attrs) {
            const track = element[0];
            const container = track.querySelector('.track__container');
            if (!container) return;

            const prev = track.querySelector('.track__nav.prev');
            const next = track.querySelector('.track__nav.next');

            if (!prev || !next) return;

            const onEnd = attrs.ngTrackOnEnd
                ? $parse(attrs.ngTrackOnEnd)
                : null;
            let canLoadMore = Boolean(onEnd);
            let pending = false;
            let destroyed = false;

            function update() {
                updateNavs(container, prev, next, canLoadMore);
            }

            function loadAtEnd() {
                if (
                    destroyed ||
                    !onEnd ||
                    !canLoadMore ||
                    pending ||
                    !isNearEnd(container)
                ) {
                    return;
                }

                const result = onEnd($scope);

                if (result === false) {
                    canLoadMore = false;
                    update();
                    return;
                }

                pending = true;
                result.then(function (hasMore) {
                    if (destroyed) return;
                    pending = false;
                    canLoadMore = Boolean(hasMore);
                    update();
                }, function () {
                    if (destroyed) return;
                    pending = false;
                    canLoadMore = true;
                    update();
                });
            }

            const onPrev = (e) => {scroll(container, 'left'); e.stopPropagation(); e.preventDefault();};
            const onNext = (e) => {
                const reachedEnd = isAtEnd(container);
                scroll(container, 'right');
                if (reachedEnd) loadAtEnd();
                e.stopPropagation();
                e.preventDefault();
            };
            const onScroll = () => {
                update();
                loadAtEnd();
            };

            prev.addEventListener('click', onPrev);
            next.addEventListener('click', onNext);
            container.addEventListener('scroll', onScroll);

            let initialTimer = setTimeout(function () {
                initialTimer = null;
                update();
                loadAtEnd();
            });
            const observer = typeof MutationObserver !== 'undefined'
                ? new MutationObserver(function () {
                    canLoadMore = Boolean(onEnd);
                    update();
                    loadAtEnd();
                })
                : null;
            if (observer) {
                observer.observe(container, {childList: true, subtree: true});
            }

            $scope.$on('$destroy', function () {
                destroyed = true;
                if (initialTimer !== null) clearTimeout(initialTimer);
                if (observer) observer.disconnect();
                prev.removeEventListener('click', onPrev);
                next.removeEventListener('click', onNext);
                container.removeEventListener('scroll', onScroll);
            });
        }
    };
}]);

app.directive('ngBindSafe', [function () {
    return {
        restrict: "A",
        scope: {
            value: "=ngBindSafe"
        },
        link: function ($scope, element, attrs) {
            $scope.$watch('value', function (value) {
                if (value) {
                    element.html(value);
                }
            });
        }
    };
}]);

app.directive('ngCrumbs', ['$compile', 'LANG', function ($compile, LANG) {
    return {
        restrict: "A",
        scope: {
            crumbs: "=ngCrumbs"
        },
        link: function ($scope, element, attrs) {
            $scope.LANG = LANG;
            $scope.$watch('crumbs', function (crumbs) {
                if (crumbs) {
                    let template = angular.element(
                        '<li data-ng-repeat="crumb in crumbs">' +
                        '<a data-ng-if="crumb.path" data-ng-navigate="!$first" data-ui-preserve-query="view,map" href="{{ LANG.path }}{{ crumb.path }}"><span>{{ crumb.name }}</span></a>' +
                        '<span data-ng-if="!crumb.path">{{ crumb.name }}</span>' +
                        '</li>'
                    );
                    angular.element(element[0]).empty().append(template);
                    $compile(template)($scope);
                }
            });

        }
    };
}]);

app.directive('ngSearch', ['$timeout', '$sce', 'rpcService', function ($timeout, $sce, rpcService) {
    return {
        restrict: "A",
        scope: {
            search: "=ngSearch",
            update: "=",
            init: "@",
            placeholder: "@",
            label: "@",
            default: "="
        },
        template: '' +
            '<label ng-if="label">{{label}}</label>' +
            '<div class="search form__input" data-ng-class="{active:query.length}">' +
            '<i class="icon-search" data-ng-click="inputClear();"></i>' +
            '<input type="text" autocomplete="off" data-ng-keyup="inputChanged($event)" data-ng-click="indexClear();" data-ng-model="query" placeholder="{{placeholder}}">' +
            '<div class="search__result" data-ng-cloak="" data-ng-if="list.length>0">' +
            '<div class="search__item" data-ng-repeat="item in list" data-ng-click="inputEnter(item);" data-ng-class="{active:$index==index}" data-ng-bind-html="highlight(item.title, query)"></div>' +
            '</div>' +
            '</div>',
        link: function ($scope, element, attrs) {
            let timer = 0;
            let delay = 0;
            let delayTimer = 0;
            $scope.query = String($scope.init || '');
            $scope.list = $scope.default || [];
            $scope.index = -1;

            let search = $scope.search || function (query) {
                return rpcService.call('search.list', {q: query}, false)
            };

            $scope.inputChanged = function ($event) {
                if ($event.keyCode === 38) {
                    if ($scope.list.length > 0) {
                        $scope.index--;
                        if ($scope.index < 0) {
                            $scope.index = $scope.list.length - 1;
                        }
                        return false
                    }
                }

                if ($event.keyCode === 40) {
                    if ($scope.list.length > 0) {
                        $scope.index++;
                        if ($scope.index > $scope.list.length - 1) {
                            $scope.index = 0;
                        }
                        return false
                    }
                }

                if ($event.keyCode === 13) {
                    if ($scope.index >= 0 && $scope.index < $scope.list.length) {
                        $scope.inputEnter($scope.list[$scope.index]);
                        return false;
                    }
                }

                if ($scope.query.length > 0) {
                    $timeout.cancel(timer);
                    const query = $scope.query;
                    timer = $timeout(function () {
                        if (query === $scope.query) {
                            search(query).then(function (result) {
                                if (query === $scope.query) {
                                    $scope.list = result;
                                }
                            })
                        }
                    }, delay);
                    delay = 200;

                    $timeout.cancel(delayTimer);
                    delayTimer = $timeout(function () {
                        delay = 0;
                    }, 200);
                } else {
                    $scope.list = $scope.default || [];
                }
            };

            $scope.inputEnter = function (item) {
                angular.element(element[0].querySelector('input'))[0].blur();
                $scope.query = item.title;
                $scope.$$postDigest(function () {
                    $scope.$applyAsync(function () {
                        $scope.update(item);
                    });
                });
            };

            $scope.inputClear = function () {
                angular.element(element[0].querySelector('input'))[0].focus();
                $scope.query = '';
                $scope.list = $scope.default || [];
                $scope.index = -1;
                $scope.$$postDigest(function () {
                    $scope.$applyAsync(function () {
                        $scope.update(null);
                    });
                });
            };

            $scope.indexClear = function () {
                $scope.index = -1;
            };

            $scope.highlight = function (text, search) {
                if (!search) {
                    return $sce.trustAsHtml(text);
                }
                return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<mark>$&</mark>'));
            };
        }
    };
}]);

app.directive('ngBookmarks', ['LANG', function (LANG) {
    return {
        restrict: "A",
        templateUrl: LANG.path + '/block/bookmarks/'
    };
}]);

app.service('currencyService', ['$cookies', 'CURRENCIES', 'LANG', 'TRANS', function ($cookies, CURRENCIES, LANG, TRANS) {
    const PRICE_OPTIONS = {
        sale: {
            thb: [1000000, 2000000, 3000000, 4000000, 5000000, 7000000, 10000000, 15000000, 20000000, 30000000],
            usd: [30000, 50000, 75000, 100000, 150000, 200000, 300000, 500000, 750000, 1000000],
            rub: [2500000, 5000000, 7500000, 10000000, 15000000, 20000000, 30000000, 50000000, 75000000]
        },
        rent: {
            thb: [5000, 10000, 20000, 30000, 40000, 50000, 80000],
            usd: [150, 300, 500, 750, 1000, 1500, 2000, 2500],
            rub: [10000, 25000, 50000, 75000, 100000, 150000, 200000]
        }
    };

    let self = this;
    let fallbackCurrency = CURRENCIES[0] || {id: null, code: 'thb', name: 'THB', icon: '฿', index: 1};
    let currentCurrency = null;
    let priceOptionsCache = {};
    const compactNumber = new Intl.NumberFormat(LANG.code, {
        maximumFractionDigits: 1,
        useGrouping: false
    });

    let compactPriceParts = function (value) {
        if (!value) return null;
        let converted = Number(value) * (self.getCurrency().index || 1);
        if (!Number.isFinite(converted) || !converted) return null;
        let scale = 1;
        // Promote to the next unit when rounding would otherwise display 1000.
        while (Math.abs(converted / scale) >= 999.95 && scale < 1000000) {
            scale *= 1000;
        }
        return {
            number: compactNumber.format(converted / scale),
            suffix: scale === 1000000 ? TRANS.COMPACT_MILLION :
                scale === 1000 ? TRANS.COMPACT_THOUSAND : ''
        };
    };

    let formatCurrencyValue = function (value, currency) {
        return currency.icon + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    this.getCurrency = function () {
        if (currentCurrency) return currentCurrency;
        let currencyId = parseInt($cookies.get('CURRENCY'));
        let currency = CURRENCIES.find(function (item) {
            return item.id === currencyId;
        });
        currentCurrency = currency || fallbackCurrency;
        return currentCurrency;
    };

    this.getPriceOptions = function (type) {
        let currency = self.getCurrency();
        let currencyCode = (currency.code || currency.name || 'thb').toLowerCase();
        let options = PRICE_OPTIONS[type];
        let values = options ? options[currencyCode] : null;

        if (!values) return [];

        let cacheKey = type + ':' + currencyCode + ':' + currency.index;
        if (!priceOptionsCache[cacheKey]) {
            priceOptionsCache[cacheKey] = values.map(function (value) {
                let thb = Math.round(value / currency.index);
                return {
                    key: thb,
                    value: formatCurrencyValue(value, currency)
                };
            });
        }

        return priceOptionsCache[cacheKey];
    };

    this.format = function (value) {
        if (!value) return '';
        let currency = self.getCurrency();
        let convertedValue = Math.round(parseFloat(value) * (currency.index || 1));
        if (isNaN(convertedValue)) return '';
        return formatCurrencyValue(convertedValue, currency);
    };

    this.formatCompact = function (value) {
        let parts = compactPriceParts(value);
        return parts ? self.getCurrency().icon + parts.number + parts.suffix : '';
    };

    this.formatCompactRange = function (minPrice, maxPrice) {
        let start = compactPriceParts(minPrice);
        let end = compactPriceParts(maxPrice);
        if (!start || !end) return '';
        let startSuffix = start.suffix !== end.suffix ? start.suffix : '';
        return self.getCurrency().icon + start.number + startSuffix + '–' + end.number + end.suffix;
    };

    this.setCurrency = function (currencyId) {
        currentCurrency = null;
        priceOptionsCache = {};
        let expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        $cookies.put('CURRENCY', currencyId, {
            path: '/',
            expires: expires
        });
    };
}]);

app.service('formService', ['$rootScope', '$q', '$http', '$cookies', '$httpParamSerializerJQLike', function ($rootScope, $q, $http, $cookies, $httpParamSerializerJQLike) {
    let self = this;
    self.submit = function (url, form) {

        let deferred = $q.defer();

        for (let key in form) {
            if (form[key] === null || form[key] === "" || key === "errors") {
                delete form[key];
            }
        }

        self.post(url, form).then(function (result) {
            deferred.resolve(result);
            clearForm(form)
        }, function (errors) {
            form.errors = errors;
            deferred.reject(errors);
        });
        return deferred.promise;
    };

    self.post = function (url, params) {
        for (let key in params) {
            if (params[key] === null || params[key] === "") {
                delete params[key];
            }
        }
        let deferred = $q.defer();
        $rootScope.$broadcast("preloader:active");

        $http({
            method: 'POST',
            url: url,
            data: params ? $httpParamSerializerJQLike(params) : null,
            headers: {
                'X-CSRFToken': $cookies.get('csrftoken'),
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (response) {
            let result = response.data;
            $rootScope.$broadcast("preloader:hide");
            if (result.success) {
                deferred.resolve(result);
            } else {
                deferred.reject(result.errors);
            }
        }, function (response) {
            $rootScope.$broadcast("preloader:hide");
            console.log('Error submit form', response)
            deferred.reject(response);
        });

        return deferred.promise;
    }

    let clearForm = function (form) {
        for (let key in form) {
            if (key === 'errors') {
                form[key] = {};
            } else {
                delete form[key];
            }
        }
    };

}]);

app.service('statService', ['$q', '$window', '$cookies', function ($q, $window, $cookies) {
    const TRACKING_COOKIE = 'rt_tracking_id'

    const UTM_PARAMS = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
    ];

    const TTL_DAYS = 360;

    let YM_ID = null;

    let GOALS = {
        POPUP: {
            YM: {name: 'POPUP'},
            GA: {name: 'popup'},
            FP: {name: 'ViewContent', params: {content_category: 'popup'}},
            PH: {name: 'popup'},
        },
        ORDER: {
            YM: {name: 'ORDER'},
            GA: {name: 'order'},
            FP: {name: 'Lead'},
            PH: {name: 'lead'},
        },
        CONTACT: {
            YM: {name: 'CONTACT'},
            GA: {name: 'contact'},
            FP: {name: 'Contact'},
            PH: {name: 'contact'},
        },
        VIEW_PROPERTY: {
            FP: {
                name: 'ViewContent', params: {
                    content_type: 'home_listing',
                    content_ids: [],
                    city: 'Pattaya', region: 'Chon Buri', country: 'TH'
                }
            },
            GA: {
                name: 'view_item', params: {
                    value: 1000,
                    currency: 'THB',
                    items: []
                }
            },
        },
        SEARCH_PROPERTY: {
            FP: {
                name: 'Search', params: {
                    content_type: 'home_listing',
                    content_ids: [],
                    city: 'Pattaya', region: 'Chon Buri', country: 'TH'
                }
            },
            GA: {
                name: 'view_item_list', params: {
                    items: []
                }
            },
        },
        INTEREST_PROPERTY: {
            FP: {
                name: 'InitiateCheckout', params: {
                    content_type: 'home_listing',
                    content_ids: [],
                    city: 'Pattaya', region: 'Chon Buri', country: 'TH'
                }
            },
            GA: {
                name: 'begin_checkout', params: {
                    value: 1000,
                    currency: 'THB',
                    items: []
                }
            },
        },
        REQUEST_PROPERTY: {
            FP: {
                name: 'Purchase', params: {
                    content_type: 'home_listing',
                    content_ids: [],
                    value: 1000.00,
                    currency: 'THB',
                    city: 'Pattaya', region: 'Chon Buri', country: 'TH'
                }
            },
            GA: {
                name: 'purchase', params: {
                    value: 1000,
                    currency: 'THB',
                    items: []
                }
            },
        }
    };

    this.init = function () {
        this.captureUtms();
        this.ensureTrackingId();
    }

    this.captureUtms = function () {
        let params = new URLSearchParams($window.location.search);
        let found = false;

        UTM_PARAMS.forEach(function (name) {
            let v = params.get(name);
            if (!v) return;

            v = ("" + v).trim();
            if (!v) return;

            if (v.length > 256) v = v.slice(0, 256);

            $cookies.put(name, v, {
                path: "/",
                expires: new Date(Date.now() + TTL_DAYS * 86400 * 1000),
            });

            found = true;
        });

        return found;
    };

    this.ensureTrackingId = function () {
        let trackingId = $cookies.get(TRACKING_COOKIE);

        if (!trackingId) {
            try {
                trackingId = crypto.randomUUID();

                $cookies.put(TRACKING_COOKIE, trackingId, {
                    path: '/',
                    expires: new Date(Date.now() + TTL_DAYS * 86400 * 1000)
                });
            } catch (error) {
            }
        }

        return trackingId;
    }

    this.initPH = function (API_KEY) {
        if (!$window.posthog || !$window.posthog.init) {
            return false;
        }
        if (posthogInited) {
            return true;
        }
        try {
            const trackingId = this.ensureTrackingId();

            $window.posthog.init(API_KEY, {
                api_host: 'https://e.renthai.com',
                ui_host: 'https://us.posthog.com',
                defaults: '2025-11-30',
                person_profiles: 'identified_only',
                autocapture: true
            });

            $window.posthog.identify(trackingId);
            $window.posthog.people.set({
                rt_tracking_id: trackingId
            });

            posthogInited = true;
            return true;
        } catch (error) {
        }
    }

    this.initYM = function (id) {
        YM_ID = id;

        if (!$window.ym || !YM_ID) {
            return false;
        }

        try {
            const trackingId = this.ensureTrackingId();
            if (!trackingId) return false;

            $window.ym(YM_ID, 'userParams', {
                'tracking_id': trackingId
            });

            return true;
        } catch (e) {
            console.warn('YM init error', e);
            return false;
        }
    };

    this.richPopupGoal = function () {
        return this._richGoal(GOALS.POPUP)
    };

    this.richOrderGoal = function () {
        return this._richGoal(GOALS.ORDER);
    };

    this.richContactGoal = function () {
        return this._richGoal(GOALS.CONTACT);
    };

    // default params = {city: 'Pattaya', region: 'Chon Buri', country: 'TH'}
    this.viewProperty = function (property_id, params) {
        if (!property_id) return;
        let viewGoal = GOALS.VIEW_PROPERTY;
        //for facebook events
        viewGoal.FP.params.content_ids = [property_id];
        if (params) viewGoal.FP.params = Object.assign(viewGoal.FP.params, params);
        //for google events
        viewGoal.GA.params.items = [{id: property_id, google_business_vertical: 'real_estate'}];
        return this._richGoal(viewGoal);
    };

    this.searchProperty = function (property_ids, params) {
        if (!property_ids || !property_ids.length) return;
        let searchGoal = GOALS.SEARCH_PROPERTY;
        //for facebook events
        searchGoal.FP.params.content_ids = property_ids;
        if (params) searchGoal.FP.params = Object.assign(searchGoal.FP.params, params);
        //for google events
        let items = [];
        for (let i = 0; i < property_ids.length; i++) {
            items.push({id: property_ids[i], google_business_vertical: 'real_estate'})
        }
        searchGoal.GA.params.items = items;
        return this._richGoal(searchGoal);
    };

    this.interestProperty = function (property_id, params) {
        if (!property_id) return;
        let interestGoal = GOALS.INTEREST_PROPERTY;
        interestGoal.FP.params.content_ids = [property_id];
        if (params) interestGoal.FP.params = Object.assign(interestGoal.FP.params, params);
        interestGoal.GA.params.items = [{id: property_id, google_business_vertical: 'real_estate'}];
        return this._richGoal(interestGoal);
    };

    this.requestProperty = function (property_id, params) {
        if (!property_id) return;
        let requestGoal = GOALS.REQUEST_PROPERTY;
        requestGoal.FP.params.content_ids = [property_id];
        if (params) requestGoal.FP.params = Object.assign(requestGoal.FP.params, params);
        requestGoal.GA.params.items = [{id: property_id, google_business_vertical: 'real_estate'}];
        return this._richGoal(requestGoal);
    };

    this._richGoal = function (goal) {
        let deferred = $q.defer();

        //gtag - is global function of Google Analytics
        if (typeof (gtag) === 'function' && goal.GA) {
            try {
                gtag('event', goal.GA.name, goal.GA.params)
            } catch (e) {
                console.error("Google Tag event exception.")
            }
        }
        //fbq facebook pixel
        if (typeof (fbq) === 'function' && goal.FP) {
            try {
                fbq('track', goal.FP.name, goal.FP.params);
            } catch (e) {
                console.error("Facebook Pixel event exception.")
            }
        }
        //posthog - is global function of PostHog
        if (window.posthog && typeof window.posthog.capture === 'function' && goal.PH) {
            try {
                posthog.capture(goal.PH.name, goal.PH.params || {});
            } catch (e) {
                console.error("PostHog capture exception.")
            }
        }
        //ym - is global function of Yandex Metrika
        if (typeof (ym) === 'function' && YM_ID && goal.YM) {
            try {
                ym(YM_ID, 'reachGoal', goal.YM.name, goal.YM.params, function () {
                    deferred.resolve();
                });
            } catch (e) {
                console.error("Yandex Metrika event exception.")
            }

        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };
}]);

app.service('rpcService', ['$rootScope', '$q', 'jsonrpc', function ($rootScope, $q, jsonrpc) {
    let self = this;

    this.call = function (method, params, pl) {
        pl = (pl !== undefined ? pl : true);
        if (params) {
            for (let key in params) {
                if (params[key] === null || params[key] === "") {
                    delete params[key];
                }
            }
        } else {
            params = {}
        }
        let deferred = $q.defer();
        if (pl) $rootScope.$broadcast("preloader:active");
        jsonrpc.request(method, params)
            .then(function (result) {
                deferred.resolve(result);
                if (pl) $rootScope.$broadcast("preloader:hide");
            }).catch(function (error) {
            deferred.reject(error);
            if (pl) $rootScope.$broadcast("preloader:hide");
            if (error.message) {
                $rootScope.$broadcast("error:message", {
                    'message': error.message.substr(error.message.indexOf(':') + 1),
                    'data': error.data ? error.data : ""
                });
            }
        });
        return deferred.promise;
    }
}]);

app.service('googleMapsLoader', ['$q', '$window', 'GOOGLE_MAPS_CONFIG', function ($q, $window, GOOGLE_MAPS_CONFIG) {
    let mapsPromise = null;
    let clustererPromise = null;

    this.load = function () {
        if (mapsPromise) return mapsPromise;
        if (!GOOGLE_MAPS_CONFIG.apiKey || !GOOGLE_MAPS_CONFIG.mapId) {
            return $q.reject(new Error('Google Maps is not configured'));
        }

        let ready;
        if ($window.google && $window.google.maps && $window.google.maps.importLibrary) {
            ready = $q.resolve();
        } else {
            let callback = '__renthaiGoogleMapsReady';
            let query = new URLSearchParams({
                key: GOOGLE_MAPS_CONFIG.apiKey,
                v: 'quarterly',
                loading: 'async',
                callback: callback
            });
            ready = appendScript(
                'https://maps.googleapis.com/maps/api/js?' + query.toString(),
                callback
            );
        }

        mapsPromise = ready.then(function () {
            return $q.all({
                core: $window.google.maps.importLibrary('core'),
                maps: $window.google.maps.importLibrary('maps'),
                marker: $window.google.maps.importLibrary('marker')
            });
        }).then(function (libraries) {
            return {
                Map: libraries.maps.Map,
                InfoWindow: libraries.maps.InfoWindow,
                LatLngBounds: libraries.core.LatLngBounds,
                AdvancedMarkerElement: libraries.marker.AdvancedMarkerElement,
                PinElement: libraries.marker.PinElement,
                event: libraries.core.event
            };
        }).catch(function (error) {
            mapsPromise = null;
            throw error;
        });
        return mapsPromise;
    };

    this.loadClusterer = function () {
        if (clustererPromise) return clustererPromise;

        if ($window.markerClusterer && $window.markerClusterer.MarkerClusterer) {
            clustererPromise = $q.resolve($window.markerClusterer.MarkerClusterer);
        } else {
            clustererPromise = appendScript(GOOGLE_MAPS_CONFIG.clustererUrl)
                .then(function () {
                    return $window.markerClusterer.MarkerClusterer;
                }).catch(function (error) {
                    clustererPromise = null;
                    throw error;
                });
        }
        return clustererPromise;
    };

    function appendScript(src, callbackName) {
        let deferred = $q.defer();
        let script = $window.document.createElement('script');
        script.async = true;
        script.src = src;

        if (callbackName) {
            $window[callbackName] = function () {
                delete $window[callbackName];
                deferred.resolve();
            };
        } else {
            script.onload = function () {
                deferred.resolve();
            };
        }
        script.onerror = function () {
            script.remove();
            if (callbackName) delete $window[callbackName];
            deferred.reject(new Error('Map script loading failed'));
        };

        $window.document.head.appendChild(script);
        return deferred.promise;
    }
}]);

app.service('projectService', ['rpcService', function (rpcService) {
    this.getProjects = function (project_filter, offset, limit, with_page) {
        return rpcService.call('project.list', {
            'project_filter': project_filter,
            'with_page': with_page,
            'offset': offset,
            'limit': limit
        });
    };

    this.getProject = function (project_id) {
        return rpcService.call('project.get', {
            'project_id': project_id
        }, false);
    };
}]);

app.service('propertyService', ['rpcService', function (rpcService) {
    this.getProperties = function (property_filter, offset, limit, with_page, preloader) {
        return rpcService.call('property.list', {
            'property_filter': property_filter,
            'with_page': with_page,
            'offset': offset,
            'limit': limit
        }, preloader);
    };

    this.getProperty = function (property_id) {
        return rpcService.call('property.get', {
            'property_id': property_id,
            'manager': true
        }, false);
    };

    this.getPage = function (propertyFilter) {
        return rpcService.call('property.page', {
            property_filter: propertyFilter
        }, false);
    };

    this.getCatalogNavigation = function (propertyFilter, offset, limit) {
        return rpcService.call('property.catalog_navigation', {
            property_filter: propertyFilter,
            offset: offset,
            limit: limit
        }, false);
    };

    this.getMapMarkers = function (propertyFilter) {
        return rpcService.call('property.map_markers', {
            property_filter: propertyFilter
        }, false);
    };
}]);

app.service('bookmarksService', ['rpcService', '$cookies', function (rpcService, $cookies) {
    const BOOKMARKS_COUNT = 'bookmarks_count';

    this.getCountFromCookie = function () {
        let count = $cookies.get(BOOKMARKS_COUNT);
        return count ? count : 0;
    };

    this.setCountToCookie = function (count) {
        $cookies.put(BOOKMARKS_COUNT, count, {path: '/'});
    };

    this.get = function (full) {
        return rpcService.call('bookmarks.get', {'full': full}, false);
    };

    this.add_property = function (property_id, full) {
        return rpcService.call('bookmarks.add_property', {'property_id': property_id, 'full': full}, false);
    };

    this.remove_property = function (property_id, full) {
        return rpcService.call('bookmarks.remove_property', {'property_id': property_id, 'full': full}, false);
    };
}]);

app.service('geoService', ['rpcService', '$q', '$cookies', function (rpcService, $q, $cookies) {
    let _geoCache = null;
    let _geoRequest = null;
    let _geoById = Object.create(null);
    let _geoByPath = Object.create(null);
    let _mapContextCache = Object.create(null);
    let self = this;

    const CURRENT_GEO_COOKIE = 'rt_current_geo';
    const TTL_DAYS = 365;

    function normalizePath(path) {
        if (path === null || path === undefined) return null;
        return String(path).replace(/^\/+|\/+$/g, '');
    }

    function indexGeo(node) {
        if (!node) return;
        if (node.id !== null && node.id !== undefined) {
            _geoById[String(node.id)] = node;
        }
        const path = normalizePath(node.path);
        if (path) {
            _geoByPath[path] = node;
        }
    }

    function setGeoCache(nodes) {
        _geoCache = Array.isArray(nodes) ? nodes.slice() : [];
        _geoById = Object.create(null);
        _geoByPath = Object.create(null);
        _geoCache.forEach(indexGeo);
    }

    this.findGeoById = function (geoId) {
        if (geoId === null || geoId === undefined) return null;
        return _geoById[String(geoId)] || null;
    };

    this.findGeoByPath = function (path) {
        const normalized = normalizePath(path);
        return normalized ? _geoByPath[normalized] || null : null;
    };

    this.findMarketGeoByPath = function (path) {
        let currentPath = normalizePath(path);
        while (currentPath) {
            const node = self.findGeoByPath(currentPath);
            if (node && node.is_market) return node;

            const separatorIndex = currentPath.lastIndexOf('/');
            if (separatorIndex < 0) break;
            currentPath = currentPath.slice(0, separatorIndex);
        }
        return null;
    };

    this.getGeoById = function (geoId) {
        const node = self.findGeoById(geoId);
        if (node) return $q.resolve({success: true, geo_node: node});

        return rpcService.call('geo.get', {geo_node_id: geoId}, false).then(function (result) {
            if (result.success && result.geo_node) self.addCacheGeo(result.geo_node);
            return result;
        });
    };

    this.getGeoByPath = function (path) {
        const normalized = normalizePath(path);
        const node = self.findGeoByPath(normalized);
        if (node) return $q.resolve({success: true, geo_node: node});

        return rpcService.call('geo.get', {path: normalized}, false).then(function (result) {
            if (result.success && result.geo_node) self.addCacheGeo(result.geo_node);
            return result;
        });
    };

    this.getGeos = function () {
        if (_geoCache !== null) return $q.resolve(_geoCache);
        if (_geoRequest) return _geoRequest;

        _geoRequest = rpcService.call('geo.list', {
            geo_filter: {
                is_market: true
            }
        }, false).then(function (data) {
            setGeoCache(data.geo_nodes || []);
            _geoRequest = null;
            return _geoCache;
        }, function (error) {
            _geoRequest = null;
            throw error;
        });
        return _geoRequest;
    };

    this.getCurrentGeoId = function () {
        try {
            const geoId = Number($cookies.get(CURRENT_GEO_COOKIE));
            return Number.isFinite(geoId) && geoId > 0 ? geoId : null;
        } catch (error) {
            return null;
        }
    };

    this.setCurrentGeoId = function (geoId) {
        if (geoId) {
            try {
                $cookies.put(CURRENT_GEO_COOKIE, geoId, {
                    path: '/',
                    expires: new Date(Date.now() + TTL_DAYS * 86400 * 1000)
                });
            } catch (error) {
            }
        } else {
            try {
                $cookies.remove(CURRENT_GEO_COOKIE, {
                    path: '/'
                });
            } catch (error) {
            }
        }
    };

    this.setCurrentGeoByPath = function (path) {
        const normalized = normalizePath(path);
        if (!normalized) return $q.resolve(null);

        return self.getGeos().then(function () {
            const market = self.findMarketGeoByPath(normalized);
            if (market) self.setCurrentGeoId(market.id);
            return market;
        });
    };

    this.getCurrentGeo = function () {
        const geoId = self.getCurrentGeoId();
        if (!geoId) return $q.resolve(null);

        return self.getGeoById(geoId).then(function (result) {
            return result.success && result.geo_node ? result.geo_node : null;
        });
    };

    this.initGeoCache = function (nodes) {
        setGeoCache(nodes);
        _geoRequest = null;
    };

    this.addCacheGeo = function (node) {
        if (!node) return;

        const cached = self.findGeoById(node.id);
        indexGeo(node);
        if (_geoCache !== null) {
            if (cached) {
                const index = _geoCache.indexOf(cached);
                if (index >= 0) _geoCache[index] = node;
            } else {
                _geoCache.push(node);
            }
        }
    };

    this.getMapContext = function (geoNodeId) {
        let key = String(geoNodeId);
        if (_mapContextCache[key]) return _mapContextCache[key];

        _mapContextCache[key] = rpcService.call('geo.map_context', {
            geo_node_id: geoNodeId
        }, false).catch(function (error) {
            delete _mapContextCache[key];
            throw error;
        });
        return _mapContextCache[key];
    };
}]);

app.service('selectionService', ['rpcService', function (rpcService) {
    this.updateItemScore = function (selection_item_id, score) {
        return rpcService.call('selection.update_item_score', {
            'selection_item_id': selection_item_id,
            'score': score
        }, false);
    };

    this.updateClientNotes = function (selection_id, client_notes) {
        return rpcService.call('selection.update_client_notes', {
            'selection_id': selection_id,
            'client_notes': client_notes
        });
    };
}]);

app.service('catalogFilterService', ['$q', 'geoService', 'LANG', 'FILTER_DATA', function ($q, geoService, LANG, FILTER_DATA) {
    let self = this;

    let CATALOG_URL_PATTERN = /\/([^\/?]+)-for-(sale|rent)(?:\/(.+?))?\/?$/;
    let RANGE_PATTERN = /(min|[\d]+)-(max|[\d]+)/;
    let BEDS = {
        '0': 0,
        '1': 1,
        '2': 2,
        '3': 3,
        '4': 3
    };
    let TYPES = FILTER_DATA.TYPES;
    if (FILTER_DATA.CURRENT_GEO) {
        geoService.addCacheGeo(FILTER_DATA.CURRENT_GEO);
    }
    (FILTER_DATA.GEOS || []).forEach(function (node) {
        geoService.addCacheGeo(node);
    });

    self.routeDataToFilter = function (data, query) {
        let match = CATALOG_URL_PATTERN.exec(data.route.split('?')[0]);
        if (!match) return $q.resolve(null);
        let p_type = self._findItem(TYPES, 'slug', match[1]);
        if (!p_type && match[1] !== 'property') return $q.resolve(null);
        let geoPath = match[3] || null;
        let geoRequest = geoPath
            ? geoService.getGeoByPath(geoPath)
            : $q.resolve({success: true, geo_node: null});

        return geoRequest.then(function (result) {
            if (!result.success) return null;
            let geoNode = result.geo_node;
            let filter = {
                'is_active': true,
                'type_id': p_type ? p_type.id : null,
                'is_sale': match[2] === 'sale' ? true : null,
                'is_rent': match[2] === 'rent' ? true : null,
                'geo_node_id': geoNode ? geoNode.id : null,
                'project_id': query['project_id'] ? query['project_id'] : null,
                'ownership_id': query['ownership_id'] ? query['ownership_id'] : null,
                'view_id': query['view_id'] ? query['view_id'] : null,
                'furnishing_id': query['furnishing_id'] ? query['furnishing_id'] : null,
                'sale_price': [null, null],
                'rent_price': [null, null],
                'area': [null, null],
                'beds': query['beds'] !== undefined ? query['beds'] : null,
                'order_by': query['order_by'] ? query['order_by'] : null,
                'view': query['view'] ? query['view'] : null,
                'show_map': query['map'] === 1 || query['map'] === '1',
                'facilities': []
            };

            if (filter.is_sale) {
                self._updateRangeValues('sale_price', filter, query);
            }

            if (filter.is_rent) {
                self._updateRangeValues('rent_price', filter, query);
            }

            self._updateRangeValues('area', filter, query);
            self._updateMultipleValues('facilities', filter, query);

            return filter
        });
    };

    function buildFilterUrl(filter, geoPath) {
        let action = filter.is_rent ? 'rent' : 'sale';
        let p_type = self._findItem(TYPES, 'id', filter.type_id);

        let url = LANG.path + '/' + (p_type ? p_type.slug : 'property') + '-for-' + action + '/';
        url += geoPath ? geoPath + '/' : "";

        if (filter.project_id) {
            url = self._appendUrlParam(url, 'project_id', filter.project_id)
        }

        if (filter.ownership_id) {
            url = self._appendUrlParam(url, 'ownership_id', filter.ownership_id)
        }

        if (filter.view_id) {
            url = self._appendUrlParam(url, 'view_id', filter.view_id)
        }

        if (filter.furnishing_id) {
            url = self._appendUrlParam(url, 'furnishing_id', filter.furnishing_id)
        }

        // url = self._setMultipleValuesToUrl(url, 'beds', filter);
        if (filter.beds !== null) {
            url = self._appendUrlParam(url, 'beds', filter.beds)
        }

        url = self._setRangeValuesToUrl(url, 'area', filter);

        if (filter.is_sale) {
            url = self._setRangeValuesToUrl(url, 'sale_price', filter);
        }

        if (filter.is_rent) {
            url = self._setRangeValuesToUrl(url, 'rent_price', filter);
        }

        if (filter.order_by) {
            url = self._appendUrlParam(url, 'order_by', filter.order_by)
        }

        if (filter.view) {
            url = self._appendUrlParam(url, 'view', filter.view)
        }

        if (filter.show_map) {
            url = self._appendUrlParam(url, 'map', 1)
        }

        url = self._setMultipleValuesToUrl(url, 'facilities', filter);

        return url;
    }

    self.filterToUrlForGeoPath = function (filter, geoPath) {
        return buildFilterUrl(filter, geoPath);
    };

    self.filterToUrl = function (filter) {
        let geoNode = filter.geo_node_id ? geoService.findGeoById(filter.geo_node_id) : null;
        if (filter.geo_node_id && !geoNode) {
            throw new Error('Unknown GeoNode #' + filter.geo_node_id);
        }
        return buildFilterUrl(filter, geoNode ? geoNode.path : null);
    };

    self._findItem = function (items, key, value) {
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item[key] === value) return item;
        }
        return null;
    };

    self._updateMultipleValues = function (key, options, data, extract) {
        if (data[key] !== undefined) {
            let multiple_str = data[key].toString();
            let multiple_values = multiple_str.split(',');
            let values = [];
            for (let i in multiple_values) {
                let value = multiple_values[i];
                if (extract) {
                    extract(values, value);
                } else {
                    values.push(value)
                }
            }
            options[key] = values
        }
    };

    self._updateRangeValues = function (key, options, data) {
        if (data[key]) {
            let optionsStr = data[key];
            let match = RANGE_PATTERN.exec(optionsStr);
            if (match) {
                options[key] = [match[1] !== 'min' ? parseInt(match[1]) : null,
                    match[2] !== 'max' ? parseInt(match[2]) : null];
            }
        }
    };

    self._extractBedNumber = function (values, value) {
        if (BEDS[value] !== undefined) {
            values.push(BEDS[value])
        }
    };

    self._setMultipleValuesToUrl = function (url, key, options) {
        if (options[key] && options[key].length > 0) {
            let values = options[key].sort(function (a, b) {
                return a - b;
            });
            return self._appendUrlParam(url, key, values.join(','));
        }
        return url;
    };

    self._setRangeValuesToUrl = function (url, key, options) {
        let range = options[key];
        if (range && range.length === 2 && (range[0] != null || range[1] != null)) {
            let value = (range[0] != null ? range[0] : 'min') + '-' + (range[1] != null ? range[1] : 'max');
            return self._appendUrlParam(url, key, value)
        }
        return url;
    };

    self._appendUrlParam = function (base, key, value) {
        let sep = (base.indexOf('?') > -1) ? '&' : '?';
        return base + sep + key + '=' + value;
    };
}]);

app.controller('appController', ['$scope', '$timeout', '$window', '$q', '$sce', '$templateRequest', 'currencyService', 'formService', 'propertyService', 'projectService', 'geoService', 'bookmarksService', 'statService', 'LANG', 'TRANS', 'MODALS', function ($scope, $timeout, $window, $q, $sce, $templateRequest, currencyService, formService, propertyService, projectService, geoService, bookmarksService, statService, LANG, TRANS, MODALS) {

    $scope.TRANS = TRANS;
    $scope.statService = statService;
    $scope.geos = [];
    $scope.currentGeo = null;

    $scope.modal = {
        active: false,
    };

    $scope.menu = {
        active: false,
    };

    $scope.currency = currencyService.getCurrency();
    $scope.salePrices = currencyService.getPriceOptions('sale');
    $scope.rentPrices = currencyService.getPriceOptions('rent');

    $scope.openModal = function (modalKey, data, form) {
        let modal = MODALS['default'];
        if (modalKey) {
            modal = Object.assign({}, modal, MODALS[modalKey])
        }
        modal.form = Object.assign(modal.form || {}, form);
        modal.data = data;
        modal.active = true;
        $scope.modal = modal;

        //rich POPUP goal
        statService.richPopupGoal();
        if (modal.form['property_id']) statService.interestProperty(modal.form['property_id']);
    };

    $scope.openPropertyModal = function (property_id, request_type_id) {
        if (property_id) {
            // preload template before start using async with getting property
            $templateRequest(LANG.path + "/block/property-modal/");

            // load property data for render in template
            propertyService.getProperty(property_id).then(function (property) {
                $scope.openModal('property', property, {
                    project_id: property.project_id,
                    property_id: property.id,
                    geo_node_id: property.geo_node_id,
                    type_id: request_type_id
                })
            })
        }
    };

    $scope.initCallManager = function (property_id) {
        if (property_id) {
            propertyService.getProperty(property_id).then(function (property) {
                if (property.manager && property.manager.phone) {
                    $window.open('tel:' + property.manager.phone.replace(" ", ""), '_self');
                } else {
                    alert("Sorry, can't call")
                }
                statService.requestProperty(property_id);
            })
        }
    };

    window.addEventListener('message', (e) => {
        if (e.data?.type === 'openVideo') {
            $scope.$apply(() => {
                $scope.openVideoModal(e.data.title, e.data.url);
            });
        }
    });

    $scope.openVideoModal = function (title, src, high) {
        $scope.modal = {
            tpl: LANG.path + "/block/video-modal/?2",
            class: "modal--iframe" + (high ? ' modal--high' : ''),
            title: title,
            data: {src: $sce.trustAsResourceUrl(src)}
        };
        $scope.modal.active = true;
    };

    $scope.openTestModal = function () {
        $scope.modal = {
            tpl: LANG.path + "/block/test-modal/",
            class: "modal--test",
        };
        $scope.modal.active = true;
    };

    $scope.openMessageModal = function (title, message) {
        $scope.modal = {
            tpl: LANG.path + "/block/message-modal/",
            title: title,
            message: message
        };
        $scope.modal.active = true;
    };

    $scope.closeModal = function () {
        $scope.modal.active = false;
    };

    $scope.openMenu = function () {
        $scope.menu.active = true;
    };

    $scope.closeMenu = function () {
        $scope.menu.active = false;
    };

    $scope.toggleMenu = function () {
        $scope.menu.active = !$scope.menu.active;
    };

    $scope.setCurrency = function (currencyId, event) {
        if (event) {
            event.preventDefault();
        }
        currencyService.setCurrency(currencyId);
        $window.location.reload();
    };

    $scope.submitForm = function (url, form, data) {
        if (data) {
            Object.assign(form, data)
        }
        form.lang = form.lang || LANG.code;
        form.geo_node_id = form.geo_node_id || geoService.getCurrentGeoId();

        formService.submit(url, form).then(function (result) {
            $scope.openMessageModal(TRANS.THANK_YOU, result.message)

            //rich ORDER goal
            statService.richOrderGoal();
            if (form['property_id']) statService.requestProperty(form['property_id']);
        });
    };

    $scope.openLink = function (url) {
        $window.open(url, '_blank')
    };

    $scope.loadPropertyImages = function (propertyId) {
        let deferred = $q.defer();
        propertyService.getProperty(propertyId).then(function (property) {
            deferred.resolve(property.images);
        })
        return deferred.promise;
    }

    $scope.loadProjectImages = function (projectId) {
        let deferred = $q.defer();
        projectService.getProject(projectId).then(function (property) {
            deferred.resolve(property.images);
        })
        return deferred.promise;
    }

    let initialBookmarksProperties = [];
    $scope.loadBookmarks = function (full) {
        $scope.bookmarks = {count: bookmarksService.getCountFromCookie(), list: []};
        bookmarksService.get(full).then(function (bookmarks) {
            $scope.bookmarks = bookmarks;
            bookmarksService.setCountToCookie(bookmarks.count);

            if (initialBookmarksProperties && initialBookmarksProperties.length > 0) {
                $scope.markBookmarks(initialBookmarksProperties);
            }
        })
    };

    $scope.initBookmarksProperty = function (property_id) {
        let property = {id: property_id, isInBookmarks: false};
        initialBookmarksProperties.push(property);
        return property
    };

    $scope.addToBookmarks = function (property_id) {
        let bookmarks = $scope.bookmarks;
        if (bookmarks && bookmarks.list && !bookmarks.list.includes(property_id)) {
            bookmarks.list.push(property_id);
            bookmarks.count += 1;
        }
        bookmarksService.add_property(property_id, $scope.bookmarks.active).then(function (bookmarks) {
            bookmarks.active = $scope.bookmarks.active;
            $scope.bookmarks = bookmarks;
            bookmarksService.setCountToCookie(bookmarks.count);
            statService.interestProperty(property_id);
        });
    };

    $scope.removeFromBookmarks = function (property_id) {
        let bookmarks = $scope.bookmarks;
        if (bookmarks && bookmarks.list) {
            let index = bookmarks.list.indexOf(property_id);
            if (index >= 0) {
                bookmarks.list.splice(index, 1);
                bookmarks.count -= 1;
            }
        }

        bookmarksService.remove_property(property_id, $scope.bookmarks.active).then(function (bookmarks) {
            bookmarks.active = $scope.bookmarks.active;
            $scope.bookmarks = bookmarks;
            bookmarksService.setCountToCookie(bookmarks.count);
        })
    };

    $scope.toggleBookmarks = function (property, update_properties) {
        let bookmarks = $scope.bookmarks;
        if (bookmarks && bookmarks.list) {
            if (bookmarks.list.includes(property.id)) {
                $scope.removeFromBookmarks(property.id);
                property.isInBookmarks = false;
            } else {
                $scope.addToBookmarks(property.id);
                property.isInBookmarks = true;
            }
        }
        if (update_properties) {
            let properties = $scope.properties || initialBookmarksProperties || [];
            for (let i = 0; i < properties.length; i++) {
                let p = properties[i];
                if (p.id === property.id) {
                    p.isInBookmarks = !p.isInBookmarks;
                    break;
                }
            }
        }
        return property;
    };

    $scope.isInBookmarks = function (property_id) {
        let bookmarks = $scope.bookmarks;
        return bookmarks && bookmarks.list && bookmarks.list.includes(property_id);
    };

    $scope.markBookmarks = function (properties) {
        // if bookmarks not loaded, update them after loaded bookmarks
        initialBookmarksProperties = properties;
        properties.forEach(function (property) {
            property.isInBookmarks = $scope.isInBookmarks(property.id)
        })
    };

    $scope.showBookmarks = function () {
        bookmarksService.get(true).then(function (bookmarks) {
            bookmarks.active = true;
            $scope.bookmarks = bookmarks;
        });
    };

    $scope.closeBookmarks = function () {
        $scope.bookmarks.active = false;
    };

    $scope.detectMac = function () {
        $scope.isMac = $window.navigator && /(Mac|iPad)/i.test($window.navigator.platform);
    };

    $scope.toggleCheckbox = function (items, item) {
        let idx = items.indexOf(item);
        if (idx > -1) {
            items.splice(idx, 1);
        } else {
            items.push(item);
        }
    };

    $scope.initGeos = function () {
        geoService.getGeos().then(function (nodes) {
            $scope.geos = nodes.filter(function (node) {
                return node.is_market;
            });
            return geoService.getCurrentGeo();
        }).then(function (node) {
            $scope.currentGeo = node && node.is_market ? node : null;
        });
    }

    $scope.currentGeoChanged = function () {
        if ($scope.currentGeo) {
            geoService.setCurrentGeoId($scope.currentGeo.id)
        } else {
            geoService.setCurrentGeoId(null)
        }
    }

    $scope.loadBookmarks();
    $scope.detectMac();
    $scope.initGeos()
}]);

app.controller('testController', ['$scope', 'formService', 'statService', 'TRANS', 'TEST_DATA', 'LANG', 'geoService', function ($scope, formService, statService, TRANS, TEST_DATA, LANG, geoService) {
    $scope.test = {
        step: 1,
        steps: 5,
        //1
        action: null,
        actions: TEST_DATA.ACTIONS,
        //2
        type: null,
        types: TEST_DATA.TYPES,
        //3
        budget: 1500000,
        budgetRange: [500000, 20000000],
        budgetStep: 100000,
        budgets: {
            'sale': {init: 3000000, range: [500000, 20000000], step: 100000},
            'rent': {init: 15000, range: [2000, 100000], step: 1000}
        },

        //4
        selectedGeoNodeIds: [],
        geos: (TEST_DATA.GEOS || []).map(function (item) {
            return Object.assign({}, item);
        }),
        emptyGeo: {id: 0, name: TRANS.ANY},

        updateGeos: function (item) {
            let i = this.selectedGeoNodeIds.indexOf(item.id);
            if (item.selected && i < 0) {
                this.selectedGeoNodeIds.push(item.id);
            } else if (i >= 0) {
                this.selectedGeoNodeIds.splice(i, 1);
            }
        },

        getBudget: function (value) {
            if (value >= 100000)
                return (value / 1000000).toFixed(1) + ' ' + TRANS.MB;
            else if (value > 9900)
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return value + ' ' + TRANS.B
        },

        setAction: function (action) {
            if (this.action === action) {
                this.action = null;
                return;
            }
            this.action = action;
            // this.next();
        },

        setType: function (type) {
            if (this.type === type) {
                this.type = null;
                return;
            }
            this.type = type;
            // this.next();
        },

        hasPrev: function (step) {
            return step > 1;
        },

        prev: function () {
            if (!this.hasPrev(this.step)) return;

            if (this.step > 1) {
                this.set(this.step - 1)
            }
        },

        hasNext: function (step) {
            if (step === 1)
                return this.action != null;
            if (step === 2)
                return this.type != null;
            return step < this.steps;
        },

        next: function () {
            if (!this.hasNext(this.step)) return;

            if (this.step < this.steps) {
                this.set(this.step + 1)
            }
        },

        set: function (step) {
            if (step === 3) {
                let budget = this.budgets[this.action.id];
                this.budget = budget.init;
                this.budgetRange = budget.range;
                this.budgetStep = budget.step;
            }
            this.step = step;
        },
        getResult: function () {
            let result = {};
            let request = {}
            if (this.action) {
                result.type_id = this.action.id === 'rent' ? 2 : 1;
            }
            if (this.type) {
                request.property_type_id = this.type.id === 'condo' ? 2 : 3;
            }

            if (this.budget && this.step > 3) {
                request.budget_max = this.budget;
            }

            if (this.selectedGeoNodeIds.length > 0) {
                request.geo_node_ids = this.selectedGeoNodeIds.slice();
            }
            result.geo_node_id = geoService.getCurrentGeoId();
            result.request = JSON.stringify(request);
            return result;
        }
    };

    $scope.submitTestForm = function (url, form) {
        form = Object.assign(form, $scope.test.getResult());
        form.lang = form.lang || LANG.code;

        formService.submit(url, form).then(function (result) {
            $scope.test.step = 6;
            // $scope.openMessageModal(TRANS.THANK_YOU, result.message)

            //rich ORDER goal
            statService.richOrderGoal();
        });
    }
}]);

app.controller('test2Controller', ['$scope', '$timeout', 'formService', 'statService', 'TRANS', 'TEST_DATA', 'LANG', function ($scope, $timeout, formService, statService, TRANS, TEST_DATA, LANG) {
    $scope.test = {
        step: 1,
        steps: 3,
        //1
        action: null,
        actions: TEST_DATA.ACTIONS,
        //2
        budget: null,
        budgets: TEST_DATA.BUDGETS,

        setAction: function (action) {
            if (this.action === action) {
                this.action = null;
                return;
            }
            this.action = action;
            $timeout(function () {
                $scope.test.next();
            }, 500)
        },

        setBudget: function (budget) {
            if (this.budget === budget) {
                this.budget = null;
                return;
            }
            this.budget = budget;
            $timeout(function () {
                $scope.test.next();
            }, 500)

        },

        hasPrev: function (step) {
            return step > 1;
        },

        prev: function () {
            if (!this.hasPrev(this.step)) return;

            if (this.step > 1) {
                this.set(this.step - 1)
            }
        },

        hasNext: function (step) {
            if (step === 1)
                return this.action != null;
            if (step === 2)
                return this.budget != null;
            return step < this.steps;
        },

        next: function () {
            if (!this.hasNext(this.step)) return;

            if (this.step < this.steps) {
                this.set(this.step + 1)
            }
        },

        set: function (step) {
            this.step = step;
        },
        getResult: function () {
            let result = {'type_id': 1};
            if (this.action) {
                result.comment = 'Action: ' + this.action.id + ' ';
            }

            if (this.budget) {
                result.comment += 'Budget: ' + this.budget;
            }
            return result;
        }
    };

    $scope.submitTestForm = function (url, form) {
        form = Object.assign(form, $scope.test.getResult());
        form.lang = form.lang || LANG.code;

        formService.submit(url, form).then(function (result) {
            $scope.test.step = 4;
            // $scope.openMessageModal(TRANS.THANK_YOU, result.message)

            //rich ORDER goal
            statService.richOrderGoal();
        });
    }
}]);

app.controller('calcController', ['$scope', function ($scope) {
    $scope.calc = {
        price: 1500000,
        priceRange: [100000, 15000000],
        priceStep: 100000,

        deposit: 20,
        depositRange: [0, 100],
        depositStep: 0.5,

        percent: 600,
        percentRange: [0, 2500],
        percentStep: 25,

        period: 10,
        periodRange: [1, 25],
        periodStep: 1,

        result: function () {
            let amount = (this.price - this.price * this.deposit / 100);
            let percents = amount * this.percent / 10000 * this.period;
            let total = amount + percents;
            return Math.floor(total / (this.period * 12));
        },

        slice1: function (percent) {
            if (percent > 50)
                return 180;
            return Math.floor(percent / 50 * 180)
        },
        slice2: function (percent) {
            if (percent < 50)
                return 0;
            return Math.floor((percent - 50) / 50 * 180)
        }

    };
}]);

app.controller('topProjectsController', ['$scope', 'projectService', 'FILTER_DATA', function ($scope, projectService, FILTER_DATA) {
    $scope.FILTER_DATA = FILTER_DATA;
    let LOAD_LIMIT = 4;

    $scope.filter = {
        type_id: FILTER_DATA.PROJECTS_TYPE_ID ? FILTER_DATA.PROJECTS_TYPE_ID : null,
        geo_node_id: FILTER_DATA.GEOS && FILTER_DATA.GEOS.length ? FILTER_DATA.GEOS[0].id : null,
        is_active: true,
        is_approve: true,
        is_sale: true,
        order_by: '-score__total'
    };

    $scope.projects = null;
    $scope.projectsCount = 0;
    $scope.projectSlide = {activeId: null};

    $scope.filterSelectType = function (type_id) {
        $scope.filter.type_id = type_id;
        $scope.filterChanged();
    };

    $scope.filterSelectGeo = function (geo_node_id) {
        $scope.filter.geo_node_id = geo_node_id;
        $scope.filterChanged();
    };

    $scope.filterChanged = function () {
        $scope.loadProjects();
    };

    $scope.loadProjects = function (offset, limit) {
        offset = offset != null ? offset : 0;
        limit = limit || LOAD_LIMIT;

        projectService.getProjects($scope.filter, offset, limit).then(function (data) {
            let projects = (offset === 0) ? data.projects : $scope.projects.concat(data.projects);
            $scope.projects = projects;
            $scope.projectsCount = data.count;
        })
    };
}]);

app.controller('topPropertiesController', ['$scope', 'propertyService', 'TRANS', 'FILTER_DATA', function ($scope, propertyService, TRANS, FILTER_DATA) {
    $scope.FILTER_DATA = FILTER_DATA;
    let LOAD_LIMIT = 4;

    $scope.filter = {
        type_id: FILTER_DATA.PROPERTIES_TYPE_ID ? FILTER_DATA.PROPERTIES_TYPE_ID : null,
        geo_node_id: FILTER_DATA.GEOS && FILTER_DATA.GEOS.length ? FILTER_DATA.GEOS[0].id : null,
        is_active: true,
        is_sale: true,
        is_rent: null,
    };

    $scope.properties = null;
    $scope.propertiesCount = 0;

    $scope.filterSelectType = function (type_id) {
        $scope.filter.type_id = type_id;
        $scope.filterChanged();
    };

    $scope.filterSelectGeo = function (geo_node_id) {
        $scope.filter.geo_node_id = geo_node_id;
        $scope.filterChanged();
    };

    $scope.filterChanged = function () {
        $scope.loadProperties();
    };

    $scope.loadProperties = function (offset, limit) {
        offset = offset != null ? offset : 0;
        limit = limit || LOAD_LIMIT;

        propertyService.getProperties($scope.filter, offset, limit).then(function (data) {
            $scope.markBookmarks(data.properties);
            let properties = (offset === 0) ? data.properties : $scope.properties.concat(data.properties);
            $scope.properties = properties;
            $scope.propertiesCount = data.count;
        })
    };
}]);

app.controller('propertiesController', ['$scope', 'propertyService', 'TRANS', 'FILTER_DATA', function ($scope, propertyService, TRANS, FILTER_DATA) {
    $scope.FILTER_DATA = FILTER_DATA;
    let LOAD_LIMIT = 8;

    $scope.filter = {
        type_id: FILTER_DATA.TYPE_ID ? FILTER_DATA.TYPE_ID : null,
        is_active: true,
        is_sale: true,
        is_rent: null,
        project_id: FILTER_DATA.PROJECT_ID ? FILTER_DATA.PROJECT_ID : null,
        sale_price: [null, null],
        rent_price: [null, null],
        beds: [],
        ownership_id: null,
        order_by: FILTER_DATA.ORDER_BY ? FILTER_DATA.ORDER_BY : null,
        facilities: []
    };

    $scope.properties = null;
    $scope.propertiesCount = 0;

    $scope.filterSelectAction = function (is_sale, is_rent) {
        if ($scope.filter.is_sale === is_sale && $scope.filter.is_rent === is_rent) return;
        $scope.filter.is_sale = is_sale;
        $scope.filter.is_rent = is_rent;
        $scope.filterChanged();
    };

    $scope.filterActionChanged = function (action) {
        $scope.filterSelectAction(action.id === 'sale', action.id === 'rent');
    };

    $scope.filterSalePriceChanged = function () {
        let filter = $scope.filter;
        if (filter.sale_price[0] && filter.sale_price[1] && filter.sale_price[1] < filter.sale_price[0]) {
            filter.sale_price[1] = filter.sale_price[0];
        }
        filter.rent_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterRentPriceChanged = function () {
        let filter = $scope.filter;
        if (filter.rent_price[1] && filter.rent_price[0] && filter.rent_price[1] < filter.rent_price[0]) {
            filter.rent_price[1] = filter.rent_price[0];
        }
        filter.sale_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterChanged = function () {
        $scope.loadProperties();
    };

    $scope.loadProperties = function (offset, limit) {
        offset = offset != null ? offset : 0;
        limit = limit || LOAD_LIMIT;
        propertyService.getProperties($scope.filter, offset, limit).then(function (data) {
            $scope.markBookmarks(data.properties);

            let properties = (offset === 0) ? data.properties : $scope.properties.concat(data.properties);
            $scope.properties = properties;
            $scope.propertiesCount = data.count;
        })
    };

    $scope.loadProperties();
}]);

app.controller('promoController', ['$scope', '$controller', 'currencyService', 'catalogFilterService', 'geoService', 'TRANS', 'FILTER_DATA', function ($scope, $controller, currencyService, catalogFilterService, geoService, TRANS, FILTER_DATA) {
    //controller inheritance from appController
    $controller('appController', {$scope: $scope});

    $scope.FILTER_DATA = FILTER_DATA;

    $scope.filter = {
        type_id: FILTER_DATA.TYPES ? FILTER_DATA.TYPES[0].id : null,
        is_sale: true,
        is_rent: null,
        project_id: null,
        geo_node_id: null,
        sale_price: [null, null],
        rent_price: [null, null],
        beds: null,
        facilities: []
    };
    $scope.isFilterActive = false;

    $scope.openFilter = function () {
        $scope.isFilterActive = true;
    };

    $scope.closeFilter = function () {
        $scope.isFilterActive = false;
    };

    $scope.filterSelectAction = function (is_sale, is_rent) {
        if ($scope.filter.is_sale === is_sale && $scope.filter.is_rent === is_rent) return;
        $scope.filter.is_sale = is_sale;
        $scope.filter.is_rent = is_rent;
        $scope.filter.rent_price = [null, null];
        $scope.filter.sale_price = [null, null];
        $scope.updateFilterPresentation($scope.filter);
    };

    $scope.filterSearchAction = function (item) {
        if (item) {
            $scope.filter.geo_node_id = item.geo_node ? item.geo_node.id : null;
            $scope.filter.project_id = item.project_id ? item.project_id : null;
            $scope.filter.type_id = item.type_id ? item.type_id : $scope.filter.type_id;
            if (item.geo_node) geoService.addCacheGeo(item.geo_node);
        } else {
            $scope.filter.geo_node_id = null;
            $scope.filter.project_id = null;
        }
    };

    $scope.searchBtnClick = function () {
        // default pattaya search
        if (!$scope.filter.geo_node_id) {
            let geoNode = FILTER_DATA.GEOS && FILTER_DATA.GEOS.length ? FILTER_DATA.GEOS[0] : null;
            if (geoNode) {
                geoService.addCacheGeo(geoNode);
                $scope.filter.geo_node_id = geoNode.id
            }
        }
        location.href = catalogFilterService.filterToUrl($scope.filter);
        return false;
    };

    $scope.filterSalePriceChanged = function () {
        let filter = $scope.filter;
        if (filter.sale_price[0] && filter.sale_price[1] && filter.sale_price[1] < filter.sale_price[0]) {
            filter.sale_price[1] = filter.sale_price[0];
        }
        filter.rent_price = [null, null];
        $scope.updateFilterPresentation(filter);
    };

    $scope.filterRentPriceChanged = function () {
        let filter = $scope.filter;
        if (filter.rent_price[1] && filter.rent_price[0] && filter.rent_price[1] < filter.rent_price[0]) {
            filter.rent_price[1] = filter.rent_price[0];
        }
        filter.sale_price = [null, null];
        $scope.updateFilterPresentation(filter);
    };

    $scope.updateFilterPresentation = function (filter) {
        let price = filter.is_sale ? filter.sale_price : filter.rent_price;
        $scope.filterLabels = {
            price: getPriceFilterLabel(price)
        };
    };

    function getPriceFilterLabel(price) {
        if (!price) return TRANS.ANY_PRICE;

        let minPrice = price[0];
        let maxPrice = price[1];
        if (minPrice && maxPrice) {
            return currencyService.formatCompactRange(minPrice, maxPrice);
        }
        if (minPrice) {
            return TRANS.FROM + ' ' + currencyService.formatCompact(minPrice);
        }
        if (maxPrice) {
            return TRANS.UNDER + ' ' + currencyService.formatCompact(maxPrice);
        }
        return TRANS.ANY_PRICE;
    }

    $scope.initDefaultSearchList = function () {
        if (FILTER_DATA && FILTER_DATA.GEOS) {
            let geos = FILTER_DATA.GEOS;
            let defaultSearch = []
            for (let i = 0; i < geos.length; i++) {
                const geoNode = geos[i];
                defaultSearch.push({
                    'title': geoNode.name,
                    'is_geo': true,
                    'geo_node': geoNode
                })
            }
            $scope.defaultSearch = defaultSearch;
        }
    }

    $scope.initDefaultSearchList();

}]);

app.controller('selectionController', ['$scope', '$q', '$controller', '$templateRequest', 'selectionService', 'LANG', function ($scope, $q, $controller, $templateRequest, selectionService, LANG) {
    $controller('appController', {$scope: $scope});

    $scope.openClientNotesModal = function (selection_id) {
        $scope.modal = {
            tpl: LANG.path + "/block/notes-modal/",
            data: {selection_id: selection_id},
            updated: false
        };
        $scope.modal.active = true;
    }

    $scope.updateClientNotes = function (selection_id, notes) {
        selectionService.updateClientNotes(selection_id, notes).then(function () {
            $scope.modal.updated = true;
        });
    }

    $scope.toggleItemScore = function (item, score) {
        item.score = item.score === score ? 0 : score;
        selectionService.updateItemScore(item.id, item.score).then(function (updated_item) {
            item.score = updated_item.score;
        });
    }

    $templateRequest(LANG.path + "/block/notes-modal/");
}]);

app.controller('isolateScope', function () {
});
